"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerListCsvConfig = void 0;
exports.customerListCsvConfig = {
    delimiter: ',',
    escapeChar: '"',
    header: true,
    quoteChar: '"',
    quotes: false,
    skipEmptyLines: 'greedy',
};
//# sourceMappingURL=constants.js.map